module.exports = __webpack_public_path__ + "img/901695703.ac03206c.png";